import { api } from "@/api/client";
import type { Alert, AlertFilters, AlertPage, AlertStats } from "@/types";

export async function fetchAlerts(filters: AlertFilters): Promise<AlertPage> {
  const params: Record<string, string> = { status: filters.status };
  if (filters.approval_type) params.approval_type = filters.approval_type;
  if (filters.actionable) params.actionable = "true";
  if (filters.q) params.q = filters.q;
  if (filters.sort) params.sort = filters.sort;
  if (filters.dir) params.dir = filters.dir;
  if (filters.page) params.page = String(filters.page);
  if (filters.per_page) params.per_page = String(filters.per_page);

  const { data } = await api.get<AlertPage>("/alerts", { params });
  return data;
}

export async function fetchAlertStats(): Promise<AlertStats> {
  const { data } = await api.get<AlertStats>("/alerts/stats");
  return data;
}

export async function dismissAlert(id: number, reason?: string): Promise<Alert> {
  const { data } = await api.post<Alert>(`/alerts/${id}/dismiss`, { reason });
  return data;
}

export async function undismissAlert(id: number): Promise<Alert> {
  const { data } = await api.post<Alert>(`/alerts/${id}/undismiss`);
  return data;
}

export async function acceptAlert(id: number): Promise<Alert> {
  const { data } = await api.post<Alert>(`/alerts/${id}/accept`);
  return data;
}

export async function unacceptAlert(id: number): Promise<Alert> {
  const { data } = await api.post<Alert>(`/alerts/${id}/unaccept`);
  return data;
}
